require("@rails/ujs").start()
require("@rails/activestorage").start()

require('./ghs');
import './cleave.min'
import './cleave-phone.us'
